import React, { createContext, useContext } from 'react';

const AssistantAdminContext = createContext<any>(null);

export const useAssistantAdminContext = () => {
  const value = useContext(AssistantAdminContext);
  if (!value) throw new Error('AssistantAdminContext missing');
  return value;
};

export const AssistantAdminProvider = ({ value, children }: { value: any; children: React.ReactNode }) => (
  <AssistantAdminContext.Provider value={value}>{children}</AssistantAdminContext.Provider>
);
